/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect, useContext } from 'react';
import { includes, isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { Container } from './styles/Container.styled';
import {
  ThreeColumnIntroBlockSection,
  ArticlePart,
  ArticleH3,
  ArticleParagraph,
  ReadMoreLabel,
  TextWrapper,
  FullWidthImage,
} from './styles/ThreeColumnIntroBlock.styled';
import useMediaQuery from '../hooks/useMediaQuery';
import AboutIntroBlock from './about-intro-block/AboutIntroBlock';

export default function ThreeColumnsIntro({ data, id, dir }) {
  const { column1Text, column2Text, title, backgroundImage } = data;
  const [toggleText, setToggleText] = useState(false);
  const { translations } = useContext(DWTCContext);
  const [label, setLabel] = useState('+Read More');
  const textLess = getTranslationByKey(translations, '-Read Less');
  const textMore = getTranslationByKey(translations, '+Read More');
  const { cssClass } = useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return '#ce445b';
    if (includes(cssClass, 'real-estate')) return '#1ba39c';
    return '#1b7bdd';
  };

  const matches = useMediaQuery('(min-width: 576px)');

  const handleAnimate = () => {
    if (matches) {
      return 'visible';
    }
    return toggleText ? 'visible' : 'hidden';
  };

  const variants = {
    hidden: { opacity: 0, y: -100, height: 0 },
    visible: { opacity: 1, y: 0, height: 'auto' },
  };

  useEffect(() => setLabel(toggleText ? textLess : textMore), [toggleText]);

  const isBrowser = typeof window !== 'undefined';
  const [isAbout, setIsAbout] = useState(false);
  const [isSustainability, setIsSustainability] = useState(false);
  const lang = dir === 'ltr' ? 'en' : 'ar';

  useEffect(() => {
    if (isBrowser) {
      setIsAbout(window.location.pathname === `/${lang}/about/`);
      setIsSustainability(window.location.pathname === `/${lang}/sustainability/`);
    }
  }, [isBrowser, lang]);

  return (
    <>
      {isAbout ? (
        <AboutIntroBlock
          data={data}
          id={id}
          dir={dir}
          className="isabout-page"
        />
      ) : (
        <ThreeColumnIntroBlockSection id={id} className={`${isAbout ? 'isabout-page' : ''}`}>
          <Container className={`${isSustainability ? 'py-5 lg:pt-[50px] lg:pb-[80px]' : ''}`}>
            <ArticlePart className="articlecontent">
              <ArticleH3
                dir={dir}
                className={`${isSustainability ? '!text-clamp22to30' : 'article_h3'}`}>
                {title}
              </ArticleH3>

              {isSustainability ? (
                <ArticleParagraph>
                  <div className="article-column">
                    <p>
                      {column1Text} {column2Text}
                    </p>
                  </div>
                </ArticleParagraph>
              ) : (
                <>
                  <ArticleParagraph>
                    <div className="article-column">
                      <p>{column1Text}</p>
                      {isEmpty(column2Text) || (
                        <TextWrapper
                          dir={dir}
                          variants={variants}
                          animate={handleAnimate()}
                          initial={matches ? 'visible' : 'hidden'}
                          transition={{ duration: 0.8, ease: 'linear' }}
                          toggle={toggleText}
                          className="toggle">
                          {column2Text}
                        </TextWrapper>
                      )}
                    </div>
                  </ArticleParagraph>
                  <ReadMoreLabel
                    toggle={toggleText}
                    onClick={() => setToggleText(!toggleText)}
                    dir={dir}
                    color={getTheme()}>
                    {label}
                  </ReadMoreLabel>
                </>
              )}
            </ArticlePart>
          </Container>
          {isEmpty(backgroundImage) || (
            <FullWidthImage>
              <LazyLoadImage src={backgroundImage.url} alt={title} />
            </FullWidthImage>
          )}
        </ThreeColumnIntroBlockSection>
      )}
    </>
  );
}